import axios from "axios"
import * as actions from "../actions/annualReturnClient"

export function getClientsForAnnualReturn(lobbyistId, annualReturn) {
  return dispatch => {
    let url = `/api/annual-return-client/${lobbyistId}/${annualReturn.AnnualReturnId}?startDate=${annualReturn.StartDate}&endDate=${annualReturn.EndDate}`
    return axios.get(process.env.REACT_APP_API_HOST + url)
      .then((response) => {
        let annualReturnClients = response.data ? response.data.$values : []
        dispatch(actions.getClientsForAnnualReturn(annualReturnClients))
      })
  }
}

export function getAnnualReturnClient(clientId, annualReturnId, annualReturnClientId) {
  return dispatch => {
    return axios.get(process.env.REACT_APP_API_HOST + `/api/annual-return-client/${clientId}/${annualReturnId}/${annualReturnClientId}`)
      .then(response => dispatch(actions.getAnnualReturnClient(response.data)))
  }
}

export function addAnnualReturnClient(annualReturnClient) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(process.env.REACT_APP_API_HOST + "/api/annual-return-client/", annualReturnClient)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.addClientToAnnualReturn(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function updateAnnualReturnClient(annualReturnClient) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(process.env.REACT_APP_API_HOST + "/api/annual-return-client/", annualReturnClient)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.updateClientForAnnualReturn(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function removeAnnualReturnClient(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.delete(process.env.REACT_APP_API_HOST + `/api/annual-return-client/${id}`)
      .then(response => {
        if (response.data.Success) {
          dispatch(actions.clearAnnualReturnClient());
        }
        resolve(response);
      })
      .catch(error => reject(error))
    })
  }
}

export function clearAnnualReturnClient() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearAnnualReturnClient())
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/actionCreators/annualReturnClient.js